import { motion } from "framer-motion";
import * as Icons from "lucide-react";

export const Technology = ({ content }) => {
  const section = content.technologySection;
  return (
    <section id="technology" data-testid="technology-section" className="relative py-24 lg:py-32">
      <div className="absolute inset-0 grid-bg opacity-25" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="section-kicker justify-center mb-4">{section.kicker}</span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl">
            {section.title}
          </h2>
          <p className="mt-5 text-white/60">
            {section.description}
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {section.items.map((t, i) => {
            const Icon = Icons[t.icon] || Icons.Cog;
            return (
              <motion.div
                key={t.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                data-testid={`tech-card-${i}`}
                className="group glass rounded-lg p-6 hover:-translate-y-1 hover:border-brand/50 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-brand/10 flex items-center justify-center mb-4 group-hover:bg-brand/20 transition-colors">
                  <Icon className="text-brand" size={22} />
                </div>
                <h3 className="font-display font-semibold text-lg">{t.title}</h3>
                <p className="mt-2 text-sm text-white/55 leading-relaxed">{t.desc}</p>
                <div className="mt-4 h-px w-0 bg-brand group-hover:w-full transition-all duration-500" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Technology;
